import { Box, Paper, Typography, Card } from "@mui/material";
import { Drawer } from "rsuite";

export default function OnboardingErrors({ open, onClose, profileDetails }) {
  return (
    <Drawer open={open} onClose={onClose} size="xs">
      <Box style={{ border: "0px solid red" }}>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          style={{ padding: "0px", paddingRight: "0px", marginTop: "75px" }}
        ></Box>
        <Box
          style={{
            padding: "5px 5px 5px 22px",
            fontSize: "18px",
            color: "#3366ff",
            borderBottom: "1px solid #EAEDED",
          }}
        >
          Surcharge Detail
        </Box>
        <Box
          style={{
            margin: "20px 5px 0px 15px",
            border: "0px solid red",
          }}
        >
          {profileDetails && (
            <Box style={{ padding: "10px 15px", fontSize: "14px" }}>
              <strong>Profile Name:</strong> {profileDetails.name}{" "}
              {profileDetails.description}
              <br />
              <strong>State:</strong> {profileDetails.stateCode}
              <br />
              <strong>Ask Confirmation:</strong>{" "}
              {profileDetails.askConfirmation ? "Yes" : "No"}
              <br />
              <Box sx={{ marginTop: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  <b>
                    <u>Brand Configurations:</u>
                  </b>
                </Typography>

                {profileDetails.surchargeBrandConfig.map(
                  (row: any, index: number) => (
                    <Card
                      key={index}
                      variant="outlined"
                      sx={{
                        marginBottom: 1.5,
                        padding: 2,
                        backgroundColor: "#f9f9f9",
                        borderRadius: 1,
                      }}
                    >
                      <Typography variant="body2">
                        <strong>Brand:</strong> {row.brand} <br />
                        <strong>Funding Sources:</strong> {row.fundingSource}{" "}
                        <br />
                        <strong>Surcharge Type:</strong> {row.surchargeType}{" "}
                        <br />
                        <strong>Surcharge Value:</strong> {row.surchargeValue}
                      </Typography>
                    </Card>
                  )
                )}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
